import { useQuery } from "@tanstack/react-query";
import { calendarioService } from "@/modules/calendario/services/calendarioService";

/** Itens agregados (eventos + reservas + devoluções) num período [inicio, fim]. */
export function useCalendario(inicioISO: string, fimISO: string) {
  return useQuery({
    queryKey: ["calendario", inicioISO, fimISO],
    queryFn: () => calendarioService.listarPeriodo(inicioISO, fimISO),
  });
}
